import React from 'react';
import { getLink } from '../links';
import { TFunction } from 'i18next';

export const error500Content = (t: TFunction) => (
  <div
    dangerouslySetInnerHTML={{
      __html: t('editorx.error.500.content', {
        link: getLink('helpCenter'),
      }),
    }}
  />
);
